import { BREAKPOINTS } from '@consts/ui';
import { achievements } from '@components/user-profile/constants';
import Achievement from '@components/achievement';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './achievements-profile.module.scss';

export default function AchievementsProfile(): JSX.Element {
  return (
    <div className={styles.achievements}>
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          [BREAKPOINTS.MD]: {
            slidesPerView: 2,
          },
          [BREAKPOINTS.LG]: {
            slidesPerView: 3,
          },
        }}
      >
        {achievements.map((achievement) => (
          <SwiperSlide key={achievement.title}>
            <Achievement {...achievement} simplify={true} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
